'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var math = require('../../utils/math.js');

function calculateWidths(_ref) {
  var {
    widths,
    containerWidth,
    actionsWidth,
    checkboxWidth,
    minWidth,
    maxWidth
  } = _ref;
  var count = widths.length; // Divide the containerWidth into equal parts.

  var netContainerWidth = containerWidth // - scrollbarWidth
  // - 1
  - actionsWidth - checkboxWidth;
  var partitionWidth = math.safeDivide(netContainerWidth, count);
  var actualMinColumnWidth = Math.min(minWidth, partitionWidth); // After accounting for the minimum possible width, this value tracks the
  // remaining width left to redistribute.

  var slack = netContainerWidth - count * actualMinColumnWidth;
  var newWidths = widths.map((value, index) => {
    var targetWidth = math.minMax(actualMinColumnWidth, value !== null && value !== void 0 ? value : partitionWidth, maxWidth);
    var slackNeeded = targetWidth - actualMinColumnWidth;
    var actualSlackUsed = Math.min(slackNeeded, slack);
    slack -= actualSlackUsed; // If there are actions, the slack remaining should be applied to the
    // second to last column.

    var lastColumnIndex = count - 1;
    var remainder = index === lastColumnIndex ? slack : 0;
    return actualMinColumnWidth + actualSlackUsed + remainder;
  });
  return newWidths;
}

exports.calculateWidths = calculateWidths;
